
import sampleSize from "lodash/sampleSize";
import words from "voca/words";
import upperCase from "voca/upper_case";

export { materializeOneOnOne } from "./teamUtil";
export { getRelativeOneOnOneMembers } from "./teamUtil";
export { deriveOneOnOneName } from "./teamUtil";
export { computeOneOnOneRoles } from "./teamUtil";

export {
	rteDocumentHasContent
} from "./rteDocumentUtil";

export const userInitialsFilter = user => {
	if ( user.firstName && user.lastName ) {
		return upperCase( `${ user.firstName[ 0 ] }${ user.lastName[ 0 ] }`.trim() );
	}
	if ( !user.displayName ) {
		return "?";
	}
	if ( user.displayName === user.email ) {
		const parts = user.email.split( "@" );
		const [ first, last, ] = parts[ 0 ].split( "." );
		const firstInitial = first || " ";
		const lastInitial = last || " ";
		return upperCase( `${ firstInitial[ 0 ] }${ lastInitial[ 0 ] }`.trim() );
	}
	const parts = words( user.displayName );
	const firstName = parts[ 0 ] || " ";
	// NOTE: some usernames are the email address, so we ignore last name here
	// so that we don't mistakenly apply the domain as the last name
	const lastName = ( !parts.includes( "@" ) && parts[ 1 ] ) || " ";
	return upperCase( `${ firstName[ 0 ] }${ lastName[ 0 ] }`.trim() );
};

export function isValidEmail( email ) {
	// From https://emailregex.com/
	// eslint-disable-next-line no-useless-escape
	const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailRegex.test( email );
}

export function makeValidatable( target ) {
	return Object.keys( target ).reduce( ( acc, key ) => {
		acc[ key ] = {
			value: target[ key ],
			validationErrors: [],
		};
		return acc;
	}, {} );
}

/** @deprecated */
// eslint-disable-next-line no-magic-numbers
export function summarizeWorkStyle( assessment, size = 4 ) {
	const summary = {
		moniker: "",
		highType: "",
		qualities: [],
		behaviors: [],
		drainers: [],
		energizers: [],
		description: "",
		showHeaderLink: false,
	};

	if ( !assessment ) {
		return summary;
	}

	summary.moniker = assessment.moniker;
	summary.highType = assessment.moniker[ 0 ].toUpperCase();
	summary.qualities = assessment?.teamingContent?.descriptors || [];
	summary.behaviors = sampleSize( assessment?.teamingContent?.naturalBehaviors, size );
	summary.drainers = sampleSize( assessment?.teamingContent?.drainers, size );
	summary.energizers = sampleSize( assessment?.teamingContent?.motivations, size );

	return summary;
}
